import { ConcurrentTenancyCheckResultDTO } from '@reposit/api-client';

export interface ConcurrencyAnalysis {
  isBlocked: boolean;
  message: string | null;
}

export const analyzeConcurrentTenancy = (
  result: ConcurrentTenancyCheckResultDTO,
  email: string
): ConcurrencyAnalysis => {
  const hasBlockedTenant = result.blockedTenants ? result.blockedTenants.some((bt) => bt.email === email) : false;
  const isBlocked = result.isBlocked || hasBlockedTenant;

  // Only return message if tenant is blocked (no success message)
  if (isBlocked) {
    return {
      isBlocked: true,
      message: 'Warning: This tenant is blocked from being added due to a concurrent tenancy/reposit around this start date.',
    };
  }

  // Not blocked - return null message (don't show success message)
  return {
    isBlocked: false,
    message: null,
  };
};
